import type { Asset } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { gql } from '@apollo/client';
import {
  getAssetTypeList,
  getLocationList,
  getManufacturerList,
  getModelList,
  getTenantList,
} from '#/graphql/queries';
import { conditionsList } from '../../utils/constants';

const columns: ColumnProps<Asset>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'displayNumber',
    caption: 'Number',
    dataType: 'string',
    visible: true,
    fixed: true,
    openOnClick: true,
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'assetTag',
    caption: 'Asset Tag',
    dataType: 'string',
    visible: true,
    openOnClick: true,
  },
  {
    dataField: 'assetType.name',
    caption: 'Asset Type',
    dataType: 'string',
    visible: true,
    headerFilter: {
      getItemList: gql(getAssetTypeList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'manufacturer.name',
    caption: 'Manufacturer',
    dataType: 'string',
    visible: true,
    headerFilter: {
      getItemList: gql(getManufacturerList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'location.name',
    caption: 'Location',
    dataType: 'string',
    visible: true,
    headerFilter: {
      getItemList: gql(getLocationList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'model.name',
    caption: 'Model',
    dataType: 'string',
    visible: true,
    headerFilter: {
      getItemList: gql(getModelList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    dataType: 'string',
    visible: true,
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'serialNumber',
    caption: 'Serial Number',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'woCount',
    caption: 'Work Orders Count',
    dataType: 'number',
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'findingsCount',
    caption: 'Findings Count',
    dataType: 'number',
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'installDate',
    caption: 'Install Date',
    dataType: 'date',
  },
  {
    dataField: 'condition',
    caption: 'Asset Condition',
    dataType: 'string',
    allowFiltering: false,
    lookup: {
      nullable: true,
      dataSource: conditionsList,
      displayExpr: 'text',
      valueExpr: 'value',
    },
  },
  {
    dataField: 'thirdPartyId',
    caption: 'Third Party ID',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'source',
    caption: 'Third Party Source',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'isParent',
    caption: 'Is Parent',
    dataType: 'boolean',
  },
];

export default columns;
